module.exports = __webpack_public_path__ + "static/assets/8a33887c84e683e7ba4b0f487eb18cce.png";